import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    del,
    formDataPatch,
    formDataPost,
    get,
    patch,
    post,
} from "helpers/api_helper";

import {
    GET_ALL_PLANS,
    GET_CURRENT_SUBSCRIPTION,
    START_FREE_TRIAL,
    GET_BILLING_HISTORY,
    BUY_SUBSCRIPTION,
    CHECK_PAYMENT_STATUS,
    DOWNLOAD_SUBSCRIPTION_INVOICE,
    CANCEL_SUBSCRIPTION,
    CALCULATE_UPGRADE_PLAN_SUBSCRIPTION,
    UPGRADE_PLAN
} from "helpers/url_helper";

export const getAllPlans = createAsyncThunk(
    GET_ALL_PLANS,
    async (payload) => {
        const response = await get(GET_ALL_PLANS);
        return response;
    }
);
export const startFreeTrial = createAsyncThunk(
    START_FREE_TRIAL,
    async (payload) => {
        const response = await post(START_FREE_TRIAL, payload);
        return response;
    }
);
export const myCurrentSubscription = createAsyncThunk(
    GET_CURRENT_SUBSCRIPTION,
    async (payload) => {
        const response = await get(GET_CURRENT_SUBSCRIPTION);
        return response;
    }
);
export const getBillingHistory = createAsyncThunk(
    GET_BILLING_HISTORY,
    async (payload) => {
        const response = await post(GET_BILLING_HISTORY, payload);
        return response;
    }
);
export const buySubscription = createAsyncThunk(
    BUY_SUBSCRIPTION,
    async (payload) => {
        const response = await post(BUY_SUBSCRIPTION, payload);
        return response;
    }
);
export const checkPaymentStatus = createAsyncThunk(
    CHECK_PAYMENT_STATUS,
    async (chargeId) => {
        const response = await get(CHECK_PAYMENT_STATUS + chargeId);
        return response;
    }
);
export const downloadSubscriptionInvoice = createAsyncThunk(
    DOWNLOAD_SUBSCRIPTION_INVOICE,
    async (payload) => {
        const response = await get(`${DOWNLOAD_SUBSCRIPTION_INVOICE}${payload}`);
        return response;
    }
);
export const cancelSubscription = createAsyncThunk(
    CANCEL_SUBSCRIPTION,
    async () => {
        const response = await get(CANCEL_SUBSCRIPTION);
        return response;
    }
);
export const calculateUpgradePlanSubscription = createAsyncThunk(
    CALCULATE_UPGRADE_PLAN_SUBSCRIPTION,
    async (payload) => {
        const response = await post(CALCULATE_UPGRADE_PLAN_SUBSCRIPTION, payload);
        return response;
    }
);
export const upgradePlan = createAsyncThunk(
    UPGRADE_PLAN,
    async (payload) => {
        const response = await post(UPGRADE_PLAN, payload);
        return response;
    }
);